<template>
  <PropertyTable :property="$store.getters.property" :second-property="$store.getters.propertyAll" :column-visible="[
    'id',
    'flangeNo',
    'typeName',
    'desc',
    'rules',
    'value',
    'unitShortName',
    'outputValue',
    'outputValueText',
    'date',
    'event',
    'quality',
  ]" secondPropertyShow tableName="TTMFacilityPropertiesForm" scroll-height="780px" />
</template>

<script setup>
/**
 * TTMFacilityPropertiesForm 
 */
import PropertyTable from './PropertyTable.vue';
import { defineProps, defineEmits } from 'vue';

// ===== затычка  =====
const emit = defineEmits([
  'setScript',
]);
const props = defineProps({
  scriptId: {
    type: Number,
    required: true,
  },
  interception: {
    type: Boolean,
    required: true,
  },
});
</script>
